import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { ForgotPasswordRequest } from '../api/forgotpassword/forgotpasswordrequest';
import { ForgotPasswordResponse, ForgotPasswordResponseDtoImpl } from '../api/forgotpassword/forgotpasswordresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';

export class ForgotPasswordAPIProcessorImpl extends APIProcessorImpl<ForgotPasswordRequest, ForgotPasswordResponse>
{

    execute(request: ForgotPasswordRequest): void
    {
        super.execute(request);
    }
     /* execute()
     {
         console.log("execute() in ForgotPasswordAPIProcessorImpl"); 

         let forgotPasswordResponse = new ForgotPasswordResponseDtoImpl(APIFeatures.SUCCESS, "Password Reset");
             
         this.getAPISuccess(forgotPasswordResponse);
     } */ 

     onSuccess(responseMapper: ResponseMapper): void 
     {
        super.onSuccess(responseMapper);
         try{
             
             if(+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
             {
                 let response = new ForgotPasswordResponseDtoImpl(APIFeatures.RESET_PASSWORD , "Reset Password Successful");
 
                      
                 this.getAPISuccess(response);
             }
         }
         catch(e)
         {
             this.getAPIFailure(new ForgotPasswordResponseDtoImpl(APIFeatures.FAILURE, this.getContext().getResources().getString(Strings.internal_server_error)));
         }
     }
 
     onFailure(responseMapper: ResponseMapper): void 
     {
       
           if(+responseMapper.getStatusCode() === StatusCodes.FORBIDDEN)
             {
                 let response = new ForgotPasswordResponseDtoImpl(APIFeatures.RESET_PASSWORD, responseMapper.getStatusMsg());
                      
                 this.getAPIFailure(response);
             }
             else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
             {
                 this.getAPIFailure(new ForgotPasswordResponseDtoImpl(APIFeatures.FAILURE, this.getContext().getResources().getString(Strings.internal_server_error)));
             }
     } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/forgotpasswordapiprocessor.tsx